module.exports = __webpack_public_path__ + "img/34.3afd2e7d.png";